const baseURL =
  process.env.NODE_ENV === 'production'
    ? '/api'
    : 'https://dev-global-changelog.fishsticksgames.com/api';

export const testAuthToken =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6ImRpbW9vb24ifQ.VyMc40ZP0Af3gANcPYTYdetcyzfiTHaLti7XE9KS1dA';

export default baseURL;
